<template>
  <div class="settings">
    <SettingsNav :app="app" />

    <OnboardHint name="queue" :app="app">
        <template slot="content">
            <h4><i>🗓️</i> What are Pending Events?</h4>
            <p>Any messages that are sent with a time-delay are stored as a pending event.</p>
            <p>If a person is in a funnel and their event is deleted, they are removed from that funnel.</p>
        </template>
        <template slot="button">
            Thanks! <span class="hint inline">and hide this message</span>
        </template>
    </OnboardHint>

    <div class="table-wrapper">
        <table class="table with-hover">
            <thead>
                <tr>
                    <th><a>ID</a></th>
                    <th><a>Funnel</a></th>
                    <th><a>Person</a></th>
                    <th><a>Funnel Started</a></th>
                    <th><a>Scheduled For</a></th>
                    <th class="no-padding has-checkbox"></th>
                </tr>
            </thead>

            <tbody>
                <tr v-if="loading">
                    <td colspan="5" class="align-center">
                        <a>Loading...</a>
                    </td>
                </tr>

                <template v-else>
                    <tr v-if="!pendingEvents.length">
                        <td colspan="5" class="align-center">
                            <a>There are no pending events.</a>
                        </td>
                    </tr>

                    <template v-else>
                        <tr v-for="(event, index) in pendingEvents" :key="'queue-item-' + index">
                            <td><a>{{event.id}}</a></td>
                            <td>
                                <router-link :to="'/funnels/' + event.funnelId" class="link">
                                    {{itemName(app.funnels, event.funnelId)}}
                                </router-link>
                            </td>
                            <td>
                                <a>{{itemName(app.people, event.personId)}}</a>
                            </td>
                            <td>
                                <a>{{time(parseInt(event.funnelStartAt))}}</a>
                            </td>
                            <td>
                                <a>{{time(event.post_date)}}</a>
                            </td>
                            <td class="has-checkbox align-center">
                                <a v-on:click="removeEvent(event)" href="javascript:;">
                                    <font-awesome-icon icon="trash" />
                                </a>
                            </td>
                        </tr>
                    </template>
                </template>
            </tbody>
        </table>
    </div>
  </div>
</template>

<script>
import SettingsNav from '@/pods/settings-nav/component.vue';
import OnboardHint from '@/pods/onboard-hint/component.vue';

var POLLER;

export default {
  props: ['app'],
  components: {
    OnboardHint,
    SettingsNav
  },
  data() {
    return {
        loading: true,
        pendingEvents: []
    };
  },
  mounted() {
    var _ = this;
    _.refresh(true);
  },
  methods: {
    refresh(initial) {
        var _ = this;

        if (initial) {
            _.loading = true;
        }

        clearTimeout(POLLER);

        _.app.requester.request({
            controller: 'events',
            action: 'list',
            s: '"status":"pending"'
        }, function(err, data) {
            if (data && data.events) {
                _.pendingEvents = data.events.reverse();
            }

            _.loading = false;

            POLLER = setTimeout(function() {
                _.refresh();
            }, 10000);
        });
    },
    itemName(collection, id) {
        var _ = this,
            item = _.app.findById(collection, id);

        if (!item) {
            return `Could not be found (#${id}).`;
        }

        if (item.name) {
            return item.name;
        }

        if (item.Name) {
            return item.Name;
        }

        if (item.Email) {
            return item.Email;
        }

        return item;
    },
    time(obj) {
        if (typeof obj === 'string') {
            obj = obj.replace(' UTC', '').replace(' ', 'T').trim();
        }

        if (!(obj instanceof Date)) {
            obj = new Date(obj);
        }

        return obj.toLocaleDateString('en-US', {
            weekday: 'short',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }) + ' at ' + obj.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
        });
    },
    removeEvent(event) {
        var _ = this;

        if (confirm('Are you sure you want to delete this event?')) {
            _.pendingEvents.splice(_.pendingEvents.indexOf(event), 1);

            _.app.requester.request({
                controller: 'events',
                action: 'delete',
                id: event.id
            });
        }
    }
  }
};
</script>
